import { captureException } from '@sentry/react';
import api from '../libs/axiosInstance';

export interface SessionCompletionData {
  sessionId: string;
  userId: string;
  runId: string;
  overallScore: number;
  sessionType: string;
  completedAt: Date;
  skills?: Record<string, number>;
}

class SessionCompletionService {
  private baseUrl = '/goals/session-sync';

  /**
   * Notify backend when a session is completed
   */
  async notifySessionCompletion(data: SessionCompletionData): Promise<void> {
    try {
      
     await api.post(`${this.baseUrl}/session-completed`, data);
    } catch (error) {
      captureException(error);
    }
  }

  /**
   * Get goal analytics for a user
   */
  async getGoalAnalytics(userId: string): Promise<any> {
    try {
      const response = await api.post(`${this.baseUrl}/analytics`, { userId });
      
      if (response.data.success) {
        return response.data.analytics;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      captureException(error);
      throw error;
    }
  }
}

export const sessionCompletionService = new SessionCompletionService();